import { useEffect, useState } from "react";
import axios from "axios";
import "./App.css";

function App() {
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState("");
  const [filter, setFilter] = useState("all");
  const [editingId, setEditingId] = useState(null);

  const API = "https://task-manager-2pqk.onrender.com";

  const fetchTasks = async () => {
    const res = await axios.get(`${API}/tasks`);
    setTasks(res.data);
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  const addTask = async () => {
    if (!title) return alert("Title required");

    if (editingId) {
      await axios.put(`${API}/tasks/${editingId}`, { title });
      setEditingId(null);
    } else {
      await axios.post(`${API}/tasks`, { title });
    }

    setTitle("");
    fetchTasks();
  };

  const toggleTask = async (id) => {
    await axios.put(`${API}/tasks/${id}`);
    fetchTasks();
  };

  const deleteTask = async (id) => {
    await axios.delete(`${API}/tasks/${id}`);
    fetchTasks();
  };

  const editTask = (task) => {
    setTitle(task.title);
    setEditingId(task._id);
  };

  const clearAll = async () => {
    for (let task of tasks) {
      await axios.delete(`${API}/tasks/${task._id}`);
    }
    fetchTasks();
  };

  // FILTER LOGIC
  const filteredTasks = tasks.filter((task) => {
    if (filter === "completed") return task.status;
    if (filter === "pending") return !task.status;
    return true;
  });

  return (
    <div className="container">
      <div className="card">
        <h1 className="title">🚀 My Task Manager</h1>

        <div className="inputBox">
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter your task..."
          />
          <button onClick={addTask} className="addBtn">
            {editingId ? "Update" : "Add"}
          </button>
        </div>

        {/* FILTER BUTTONS */}
        <div className="filters">
          <button onClick={() => setFilter("all")}>All</button>
          <button onClick={() => setFilter("completed")}>Done</button>
          <button onClick={() => setFilter("pending")}>Pending</button>
        </div>

        <ul>
          {filteredTasks.map((task) => (
            <li key={task._id} className="item">
              <span
                onClick={() => toggleTask(task._id)}
                className={task.status ? "completed" : ""}
              >
                {task.title}
              </span>

              <div>
                <button onClick={() => editTask(task)}>✏️</button>
                <button
                  onClick={() => deleteTask(task._id)}
                  className="deleteBtn"
                >
                  ❌
                </button>
              </div>
            </li>
          ))}
        </ul>

        {/* FOOTER */}
        <div className="footer">
          <p>Total: {tasks.length}</p>
          <button onClick={clearAll} className="clearBtn">
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;